import { useEffect, useState } from "react";


export function GameTimer({
    timeLimit,
    isRunning,
    timerStartTime,
  
    controlColor,
    onControlColor,
  
    onTimeUp,
  }: {
    timeLimit: number;
    isRunning: boolean;
    timerStartTime: number;
  
    controlColor: string;
    onControlColor: string;
  
    onTimeUp: () => void;
  }) {
    const [secondsLeft, setSecondsLeft] = useState(timeLimit);
  
    
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
      useEffect(() => {
      if (!isRunning) {
        return;
      }
  
      const interval = setInterval(() => {
        const elapsedSeconds = Math.floor((Date.now() - timerStartTime) / 1000);
        const newSecondsLeft = Math.max(0, timeLimit - elapsedSeconds);
  
        setSecondsLeft(newSecondsLeft);
  
        if (newSecondsLeft === 0) {
          onTimeUp();
          clearInterval(interval);
        }
      }, 100);
  
      return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeLimit, isRunning, timerStartTime]);
  
    return (
      <StatelessTimer
        secondsLeft={secondsLeft}
        controlColor={controlColor}
        onControlColor={onControlColor}
      />
    );
  }

function StatelessTimer({
    secondsLeft,
  
    controlColor,
    onControlColor,
  }: {
    secondsLeft: number;
  
    controlColor: string;
    onControlColor: string;
  }) {
    return (
      <div
        style={{
          background: controlColor,
          color: onControlColor,
          padding: "2cqw 0",
          borderRadius: "1.5cqw",
          fontSize: "6cqw",
  
          width: "18cqw",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "fit-content",
  
            lineHeight: "1",
            margin: "0 auto",
            paddingBottom: "0.2em",
          }}
        >
          <div
            style={{
              transform: "translateY(-5.6%)",
            }}
          >
            :
          </div>
          <div
            style={{
              position: "relative",
            }}
          >
            {/* use fixed 0 to keep the width consistent */}
            <div
              style={{
                visibility: "hidden",
              }}
            >
              {secondsLeft
                .toString()
                .padStart(2, "0")
                .split("")
                .map(() => "0")
                .join("")}
            </div>
            <div
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                textAlign: "center",
              }}
            >
              {secondsLeft.toString().padStart(2, "0")}
            </div>
          </div>
        </div>
        <div
          style={{
            fontSize: "0.5em",
            lineHeight: "1",
            textAlign: "center",
          }}
        >
          Time left
        </div>
      </div>
    );
  }